const cardItems = [
  {
    img: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20with%20traditional%20costume%20characters%20in%20ancient%20palace%2C%20warm%20golden%20lighting%2C%20cinematic%20composition%2C%20film%20poster%20aesthetic%2C%20dramatic%20mood&width=600&height=800&seq=card-show-01&orientation=portrait",
    tag: '古装传奇',
    title: '长安风云录',
    desc: '大唐盛世权谋史诗',
    score: '9.8',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Modern%20romantic%20drama%20poster%20with%20couple%20at%20sunset%20city%20street%2C%20warm%20golden%20hour%20lighting%2C%20film%20poster%20aesthetic%2C%20emotional%20romantic%20mood&width=600&height=800&seq=card-show-02&orientation=portrait",
    tag: '都市情感',
    title: '遇见你的那天',
    desc: '高甜治愈口碑之作',
    score: '9.6',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Crime%20thriller%20drama%20poster%20with%20detective%20in%20rainy%20alley%2C%20neon%20noir%20lighting%2C%20film%20poster%20aesthetic%2C%20suspenseful%20moody%20atmosphere&width=600&height=800&seq=card-show-03&orientation=portrait",
    tag: '悬疑刑侦',
    title: '迷雾追踪',
    desc: '年度最佳烧脑刑侦剧',
    score: '9.5',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Martial%20arts%20drama%20poster%20with%20swordsman%20in%20bamboo%20forest%2C%20misty%20atmosphere%2C%20film%20poster%20aesthetic%2C%20classic%20wuxia%20style&width=600&height=800&seq=card-show-04&orientation=portrait",
    tag: '武侠江湖',
    title: '江湖夜雨',
    desc: '新派武侠诚意之作',
    score: '9.3',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Youth%20romance%20drama%20poster%20with%20young%20couple%20in%20school%20uniform%2C%20cherry%20blossom%20background%2C%20bright%20fresh%20lighting%2C%20film%20poster%20aesthetic&width=600&height=800&seq=card-show-05&orientation=portrait",
    tag: '青春偶像',
    title: '星光之恋',
    desc: '甜度超标的浪漫青春',
    score: '9.1',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Family%20drama%20poster%20with%20warm%20home%20interior%2C%20family%20members%20together%2C%20soft%20natural%20lighting%2C%20film%20poster%20aesthetic%2C%20heartwarming%20atmosphere&width=600&height=800&seq=card-show-06&orientation=portrait",
    tag: '家庭伦理',
    title: '家和万事兴',
    desc: '暖心家庭情感大戏',
    score: '9.0',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Korean%20drama%20poster%20style%20with%20romantic%20couple%20in%20Seoul%20street%2C%20soft%20pastel%20lighting%2C%20film%20poster%20aesthetic%2C%20Korean%20wave%20style&width=600&height=800&seq=card-show-07&orientation=portrait",
    tag: '韩剧精选',
    title: '星光彼岸',
    desc: '口碑炸裂年度韩剧',
    score: '9.4',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">精选剧集</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            编辑精选高分好剧，每一部都值得细细品味
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-7 gap-4 md:gap-5 max-w-7xl mx-auto">
          {cardItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={`${item.title} - ${item.desc}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-background-950/70 text-background-50 text-[10px] font-medium backdrop-blur-sm">
                  {item.tag}
                </div>
                <div className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-primary-500/90 text-background-50 text-xs font-bold backdrop-blur-sm">
                  {item.score}
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-950 font-heading mb-1 group-hover:text-primary-500 transition-colors truncate">{item.title}</h3>
                <p className="text-xs text-foreground-500 truncate">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}